export const menuData=[
    {title: 'About', link: '/about'},
    {title: 'Areas', link: '/areas'},
    {title: 'Pricing', link: '/pricing'},
    {title: 'FAQ', link: '/faq'},
]